export const /** @type {?} */ FIRST_LOAN_FORM = 'FIRST_LOAN_FORM';
export const /** @type {?} */ SECOND_LOAN_FORM = 'SECOND_LOAN_FORM';
export const /** @type {?} */ LOGIN = 'LOGIN';
export const /** @type {?} */ IN_PROCESS_LOAN = 'IN_PROCESS_LOAN';
export const /** @type {?} */ REJECTED_LOAN = 'REJECTED_LOAN';
export const /** @type {?} */ LOAN_CONFIRMATION = 'LOAN_CONFIRMATION';
export const /** @type {?} */ OFFLINE_CONTRACT = 'OFFLINE_CONTRACT';
export const /** @type {?} */ DISBURSEMENT = 'DISBURSEMENT';
export const /** @type {?} */ ACTIVE_NORMAL = 'ACTIVE_NORMAL';
export const /** @type {?} */ IN_DEBT = 'IN_DEBT';
export const /** @type {?} */ PAIDBACK_PENDING = 'PAIDBACK_PENDING';
export const /** @type {?} */ DIGITAL_CONTRACT = 'DIGITAL_CONTRACT';
export const /** @type {?} */ PAIDBACK = 'PAIDBACK';
export const /** @type {?} */ EMPTY_LOAN = 'EMPTY_LOAN';
export const /** @type {?} */ FAQ = 'FAQ';
export const /** @type {?} */ OTHER = 'OTHER';
